import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "DjangoCamp was bangin'! (before unseen epic last slide of my talk)",
  "description": "",
  "published": "2010-12-13T00:00:00.000Z",
  "redirect_from": ["/blog/djangocamp-was-bangin-before-unseen-epic-last-slide-of-my-talk/swizec/1527"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This Saturday two very amazing things happened.`}</p>
    <p><strong parentName="p">{`1.`}</strong>{` There was the DjangoCamp at Cyberpipe, which turned out to be an awesome event. Sixteen people showed up and it seems that's pretty much the ideal group-size for serious and stimulating discussion on a topic. And by serious and stimulating I of course mean completely off the charts nerdy, geeky and unmoderated.`}</p>
    <p>{`We covered everything from obscure kernel hacks that make your TCP stack noncompliant to shave 10 milliseconds off every page load, to the finer nuances between feeling stupid and your users acting stupid.`}</p>
    <p>{`You know you're at a great event when someone asking "Hey, does anyone do any testing?" immediately shuts down the current talk and devolves into a 45 minute debate.`}</p>
    <p>{`Anywho, I shared a few thoughts about forcing django to run on Google's AppEngine. The debate started raging and I never managed to get to the epically awesome last slide.`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "http://www.slideshare.net/Swizec/appenginedjango",
          "title": "Appengine+django"
        }}>{`Appengine+django`}</a></strong></p>
    <p>{`View more `}<a parentName="p" {...{
        "href": "http://www.slideshare.net/"
      }}>{`presentations`}</a>{` from `}<a parentName="p" {...{
        "href": "http://www.slideshare.net/Swizec"
      }}>{`Swizec`}</a>{`.`}</p>
    <p><strong parentName="p">{`2.`}</strong>{` After the `}{`*`}{`camp a bunch of us got together and hijacked Cyperpipe's movie theatre rooom thing to have a private screening of V for Vendetta. Despite this being a haphazardly organized last-minute sort of event, 14 people showed up. Which I think is a great success for an event that started out as an idea 4 days before it happened.`}</p>
    <p><strong parentName="p">{`3.`}</strong>{` I'm sure there was also an off-by-one error somewhere.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.jurecuhalev.com/blog/2010/12/12/djangocampljubljana-the-day-after/&a=30315142&rid=c83c0a12-1123-45e7-a531-ab0f6d852ca2&e=a055d37a306e06c9ee213b5992c1ca54"
        }}>{`DjangoCampLjubljana - the day after`}</a>{` (jurecuhalev.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://code.google.com/appengine/articles/django-nonrel.html"
        }}>{`Running Pure Django Projects on Google App Engine`}</a>{` (code.google.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=c83c0a12-1123-45e7-a531-ab0f6d852ca2",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      